<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      
	  <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:22%">
            	<el-date-picker	v-model="query.date" type="daterange" style="width:100%"
              	range-separator="至"
              	start-placeholder="开始日期"
              	end-placeholder="结束日期"
              	value-format="yyyy-MM-dd" :unlink-panels="false" @change="ischange=true">
            	</el-date-picker>
          </el-form-item>
		  <el-form-item style="width:13%">
          	  <el-select v-model="query.type" clearable remote  filterable placeholder="请选择流水类型" @change="ischange=true">
	          	  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>          
          </el-form-item>
		  <el-form-item>
			  <el-button type="primary" icon="el-icon-search" @click="getlists()">搜索</el-button>
		  </el-form-item>
		  <el-form-item>
			  <el-button type="danger" icon="el-icon-search" @click="addmoney()">充值</el-button>
		  </el-form-item>
		  <el-form-item>
			  <template slot-scope="scope">
				  <div style="font-size:.5rem;color:#909399">当前预存款：<span style="font-size:.9rem;color:#E6A23C;font-weight:bold">{{balance}}</span></div>
			  </template>
		  </el-form-item>
      </el-form>

	  <div class="backborder2" style="margin-top:10px">
			<el-table :data="lists" style="width:100%" v-loading="orderLoading">
				<el-table-column label="流水编号">
					<template slot-scope="props">
						<span style="float:left;width:100%">{{props.row.rateSN}}</span>
						<span style="float:left;width:100%;font-size:.7rem;color:#909399">关联单号：{{props.row.orderSn}}</span>
						<span style="float:left;font-size:.7rem;color:#909399">流水来源：{{props.row.typename}}</span>
						<span style="float:left;margin-left:2%;font-size:.7rem;color:#909399">操作人：{{props.row.managername}}</span>
					</template>
				</el-table-column>
				<el-table-column label="流水类型" prop="ratetype" width="120"></el-table-column>
				<el-table-column label="扣费类型" width="120" align="center">
					<template slot-scope="props">
						<span v-if="props.row.rate_style=='费率'">{{props.row.rate_style}}<i style="margin-left:.5rem;font-size:.5rem;color:#fff;background:#E6A23C;padding:.1rem .2rem;border-radius:5px;font-style:normal">{{props.row.rate}}%</i></span>
						<span v-if="props.row.rate_style=='固定金额'">{{props.row.rate_style}}</span>
					</template>
				</el-table-column>
				<el-table-column label="目标金额" prop="payamount" align="center" width="120"></el-table-column>						
				<el-table-column label="新增/退还金额" prop="cutmoney" align="center" width="120">
					<template slot-scope="props">
						<span v-if="props.row.cutmoney >= 0" style="color:#67C23A">{{props.row.cutmoney}}</span>
						<span v-if="props.row.cutmoney < 0" style="color:#F56C6C">{{props.row.cutmoney}}</span>
					</template>
				</el-table-column>
				<el-table-column label="时间" prop="inputtime" align="center" width="170"></el-table-column>	
				<el-table-column label="详情" prop="reason" width="200"></el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<a href="javascript:;" @click="gopay(scope.row.id)" v-if="scope.row.rate_id==1 && scope.row.type==1 && scope.row.istrue==0" style="float:left;margin-right:5%;width:2rem;height:2rem;background:#409EFF;border-radius:50%;"><img src="../../assets/gopay.png" style="float:left;width:60%;margin:20% 0 0 20%"/></a>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
		        <el-pagination 
		            @size-change="orderpageSizeChange" 
		          	@current-change="orderpageCurrentChange"
		          	:current-page="query.p"
		          	:page-sizes="[10, 20, 50]"
		          	:page-size="query.rollpage"
		          	layout="total, sizes, prev, pager, next, jumper"
		          	:total="rows">
		        </el-pagination>
	   		</div>
		</div>

		<!-- 充值金额 -->
		<el-dialog title="充值金额" :visible.sync="addmoneyDialog"  width="20%" top="20vh">
			<el-input type="primary" v-model="addbalance.money" placeholder="请输入充值金额"></el-input>
			<div slot="footer" class="dialog-footer">
            	<el-button size="small" @click="addmoneyDialog = false">取 消</el-button>
            	<el-button size="small" type="primary" :loading="saveLoading" @click="Savemoney">确 认</el-button>
            </div>
		</el-dialog>
          	 
  </div>
  </transition>  
</template>

<script>

export default {
 
  data () {
    return {
        url:this.GLOBAL.domain+"Balancetemp/index",
        transitionshow:true,
        actionauth:'', //功能权限
		ischange:false,
		orderLoading:false,
		lists:[],
		rows:0,
		query: {
			act:'lists',
			token:this.$cookies.get('token'),
			date:[],
			type:'',
			p:1,
			rollpage:10
		},

		typelists:[],
		addmoneyDialog:false,

		addbalance: {
			act:'addbalance',
			token:this.$cookies.get('token'),
			money:''
		},
		saveLoading:false,
		balance:0.00,
    }
  },
    
  mounted(){  
    this.getactionauth();
	this.getratetypelists(); //流水类型
	this.getlists(); //流水记录
	this.getbalance(); //获取经销商预存款金额
  },
  
  methods:{
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },

	/** 获取当前经销商预存款金额 **/
	getbalance() {
		var resource = this.$resource(this.url);
		resource.save({act:'getbalance',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
				this.balance=result.balance;
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
	},
    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

	/** 获取预存款消费类型列表 **/
	getratetypelists() {
		var resource = this.$resource(this.url);
        resource.save({act:'ratetypelists',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
			    this.typelists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
	},

	/** 获取预存款流水信息 **/
	getlists() {
		if(this.ischange==true) {
			this.query.p=1;
			this.query.rollpage=10;
		}

		this.orderLoading=true;
        var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.orderLoading=false;
	        }else{
			    this.lists = JSON.parse(Base64.decode(res.data.Data));
		        this.rows=parseInt(res.data.count);
				this.orderLoading=false;
				if(this.ischange==true) this.ischange=false;
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
			this.orderLoading=false;
        });
	},

	/** 下一页 **/
  	orderpageSizeChange(val) {
  	    this.query.rollpage = val;
        this.getlists();
  	},
  	/** 下一页 **/
  	orderpageCurrentChange(val) {
  	    this.query.p = val;
        this.getlists();
  	},

	/** 充值金额 **/
	addmoney() {
		this.addmoneyDialog=true;
		this.addbalance.money='';
	},

	/** 充值 **/
	Savemoney() {
		this.saveLoading=true;
		var resource = this.$resource(this.url);
		resource.save(this.addbalance).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.saveLoading=false;
	        }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
				this.saveLoading=false;
				
				const div = document.createElement('div');
    			div.innerHTML = result.url;
    			document.body.appendChild(div);
    			document.forms.alipaysubmit.submit();
				
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
			this.saveLoading=false;
        });
	},

	/** 去支付 **/
	gopay(id) {
		var resource = this.$resource(this.url);
		resource.save({act:'gopay',token:this.$cookies.get('token'),id:id}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
				const div = document.createElement('div');
    			div.innerHTML = result.url;
    			document.body.appendChild(div);
    			document.forms.alipaysubmit.submit();
				
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
			this.saveLoading=false;
        });
	}


   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Balancetemp.vue